/**
 * app通用数据
 */
// 是否dev环境
const IS_DEV = process.env.VUE_APP_ENV === 'dev';
const state = {
   IS_DEV: process.env.VUE_APP_ENV === 'dev',
  version: 'v1.0.0',
  // 医路航appid (开发环境：信尚安，生产环境：医路航)
  appid: IS_DEV ? 'wx92906fee5cb09f1a' : 'wx1d5dbdc2760788da',
  // 图片地址
  qiniuBaseUrl: IS_DEV ? 'https://image.xinsec.com.cn/' : 'https://img.xinsec.com.cn/',
  // 小程序码
  qrcodeUrl: '',
  // 百度token
  baiduToken: '',
  // letterArr: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
  letterArr: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Z', 'X', 'C', 'V', 'B', 'N', 'M'],
  // 设备信息
  deviInfo: {
    screenId: '', // 大屏id
    name: '', // 名称
    model: '', // 型号
    deviceId: '123123123', // 设备编号
    mac: '', // mac地址
    buildId: '1241915742618664962', // 建筑id
    floor: 1, // 楼层
    x: 0, // x坐标
    y: 0, // y坐标
    poiId: 6914, // 6914\6996
    status: '', // 状态
    createTime: 0, // 创建时间
    lastTime: 0, // 最后修改时间
    delFlag: 0,
    isPortrait: false // 是否竖屏
  },
  // 大屏配置信息
  baseSettingInfo: {
    // 功能模块权限
    'initModuleList': [{
      'id': '1', // 功能模块id
      'code': '12154545', // 编码
      'value': '吴系挂'// 名称
    }],
    'basiSetting': {
      'settingId': 1, // 设置id
      'buildId': '', // 建筑id
      'buildName': '', // 大屏名称
      'imageLogo': '', // logo
      'isShowCopyRight': 1, // 版权信息
      'funModule': ''// 功能设置
    }
  },
  // 功能模块
  FUN_MODULE: {
    SYMPTOM: 'symptom', // 查症状
    DEPT: 'dept', // 找科室
    BUILDING: 'floor', // 查楼栋
    INFO: 'info', // 医院资讯
    INTROD: 'introd', // 医院介绍
    DOCTOR: 'doctor',// 找专家
    ALLOT: 'allot',// 排班
  }
};

const getters = {
};

const mutations = {
  set_deviInfo: (state, val) => {
    state.deviInfo = val;
  },
  set_baseSettingInfo: (state, val) => {
    state.baseSettingInfo = val;
  },
  set_qrcodeUrl: (state, val) => {
    state.qrcodeUrl = val;
  },
  set_baiduToken: (state, val) => {
    state.baiduToken = val;
  },
  set_appid: (state, val) => {
    state.appid = val;
  },
  set_isPortrait: (state, val) => {
    console.log(state, val)
    state.isPortrait = val;
  }
};

const actions = {
  // 是否竖屏
  isPortraitFn ({ commit }) {
  // 获取屏幕的宽和高
    const width = window.innerWidth;
    const height = window.innerHeight;
    // 计算宽高比
    const aspectRatio = width / height;
    console.log(aspectRatio < 1 ? '竖屏比例' : '横屏比例');
    // 判断是否为竖屏模式
    commit('set_isPortrait', aspectRatio < 1);
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
